import {
  alias,
  custom,
  deserialize,
  list,
  object,
  serializable,
} from 'serializr';
import { JiraIssueType } from './jira-issue-type.model';
import { Deserializable } from '@models/deserializable';

export class JiraProject implements Deserializable {
  @serializable
  public id: number;
  @serializable
  public name: string;
  @serializable
  public key: string;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public avatarUrls: Map<string, URL>;

  @serializable(alias('issuetypes', list(object(JiraIssueType))))
  public issueTypes: JiraIssueType[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(JiraProject, input));
  }
}
